export default "/images/6823327d0756e8dfcb8013549809212d.avif";